import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHoleProtectioningSm = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 25 25",
	...props,
	children: [
		/* @__PURE__ */ _jsx("g", {
			id: "white",
			children: /* @__PURE__ */ _jsx("g", {
				className: "cls-5",
				children: /* @__PURE__ */ _jsx("polygon", {
					className: "icon-white",
					points: "12.47 8.89 3.49 14 3.49 14.93 12.51 20.14 21.47 14.97 21.47 14.03 12.47 8.89"
				})
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			id: "grey",
			children: /* @__PURE__ */ _jsx("path", {
				className: "icon-outline",
				d: "m21.72,14.06s0-.03,0-.04h0s-.01-.04-.03-.07c0-.01-.02-.02-.04-.04-.02-.01-.03-.02-.04-.03l-9.02-5.21c-.07-.04-.16-.04-.23,0L3.39,13.83s-.03.02-.05.04c0,.01-.02.02-.03.05,0,0,0,.02-.01.03h0v.03s0,.03,0,.05v.94c0,.08.04.16.12.2l9.03,5.21s.02.01.05.02c.02,0,.04,0,.05,0s.04,0,.07-.01c.01,0,.03,0,.05-.02l8.96-5.18c.07-.04.12-.12.12-.2v-.94Zm-9.43,5.32v.4L3.74,14.84v-.4l8.56,4.94Zm8.73-5.31l-8.5,4.91L3.97,14.03l8.5-4.91,8.56,4.94Zm.23.4v.4l-8.5,4.91v-.4l8.5-4.91Zm-17.89-.52h0Zm9.11,6.38h0s0,0,0,0Z"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			id: "color",
			children: /* @__PURE__ */ _jsxs("g", { children: [
				/* @__PURE__ */ _jsx("path", {
					className: "icon-highlight",
					d: "m7.5,13.58c-.39-.22-1-.22-1.38,0-.2.12-.31.28-.31.45s.11.34.32.46c.19.11.44.17.69.17s.5-.06.69-.17c.2-.12.31-.28.31-.45s-.11-.34-.32-.46Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "icon-highlight",
					d: "m18.73,13.58c-.39-.22-1-.22-1.38,0-.2.12-.31.28-.31.45s.11.34.32.46c.2.11.44.17.69.17s.49-.06.69-.17c.2-.12.31-.28.31-.45s-.11-.34-.32-.46Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "icon-highlight",
					d: "m13.19,16.71c-.39-.22-1-.23-1.38,0-.2.12-.31.28-.31.45s.11.34.32.46c.19.11.44.17.69.17s.49-.06.69-.17c.2-.12.31-.28.31-.45s-.11-.34-.32-.46Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "icon-highlight",
					d: "m13.19,10.54c-.39-.22-.99-.23-1.38,0-.2.12-.31.28-.31.46s.11.34.32.46c.19.11.44.17.69.17s.49-.06.69-.17c.2-.12.31-.28.31-.45s-.11-.34-.32-.46Z"
				})
			] })
		})
	]
});
export default SvgHoleProtectioningSm;
